import { render, staticRenderFns } from "./ParametrosGenerales.vue?vue&type=template&id=f7d58c04"
import script from "./ParametrosGenerales.vue?vue&type=script&lang=js"
export * from "./ParametrosGenerales.vue?vue&type=script&lang=js"
import style0 from "./ParametrosGenerales.vue?vue&type=style&index=0&id=f7d58c04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports